module.exports = __webpack_public_path__ + "img/aboutUsBg.477ff713.png";